import { getCurrentImprintAreaKey, getCurrentImprintProcessType } from '../../main/selectors';

import { checkAllowMultipleArts } from '../../utils/processTypeUtil';
import { createSelector } from '@reduxjs/toolkit';
import { getImprintOptionMaxColorCount } from '../../imprintarea/selectors';

export const getCanvasFocusElement = createSelector(
  getCurrentImprintAreaKey,
  (state) => state.nextgenUi,
  (currentCanvasKey, nextgenUi) => {
    return nextgenUi.canvasFocusElement && nextgenUi.canvasFocusElement[currentCanvasKey];
  }
);

export const getIsMultipleArtMultipleColor = createSelector(
  getCurrentImprintProcessType,
  getImprintOptionMaxColorCount,
  (processType, maxColorCount) => {
    return checkAllowMultipleArts(processType) && maxColorCount > 1;
  }
);

export const getImageByGuid = createSelector(
  getCurrentImprintAreaKey,
  (state) => state.imageDict,
  (_, guid) => guid,
  (currentCanvasKey, imageDict, guid) => {
    const imageList = imageDict[currentCanvasKey] ? imageDict[currentCanvasKey] : [];
    return imageList.find((image) => image.ui.guid === guid);
  }
);
